/**
 * Minister filter states for credential request detail page
 */
export type MinisterFilterState = 'all' | 'selected' | 'available'

/**
 * Labels for each filter state
 */
export const MINISTER_FILTER_LABELS: Record<MinisterFilterState, string> = {
  all: 'Todos',
  selected: 'Seleccionados',
  available: 'No seleccionados',
}

/**
 * Get all filter options for segmented control
 */
export function getMinisterFilterOptions() {
  return [
    { value: 'all' as const, label: MINISTER_FILTER_LABELS.all },
    { value: 'selected' as const, label: MINISTER_FILTER_LABELS.selected },
    { value: 'available' as const, label: MINISTER_FILTER_LABELS.available },
  ]
}
